import {useMutation, useQuery} from "@tanstack/react-query";
import {UserService} from "../../services";
import {handleResponse, queryClient} from "./setup";
import Noti from "../../view/components/general/noti";
import {AccountService} from "../../services/requests/account";
import { ROUTES } from "../../constants";
import { useNavigate } from "react-router-dom";

const useChangeAccountPassword = ({
 onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: AccountService.changeAccountPassword,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          console.log(data)
          Noti("success", data?.data?.msg)
          onSuccess();
        }
      })
    },
  })
}

const useBlockingAccount = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: AccountService.blockingAccount,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          console.log(data)
          Noti("success", data?.data?.msg)
          onSuccess();
        }
      })
    },
  })
}

const useGetLoginHistory = (params: any) => {
  return useQuery({
    queryKey: ["getDoctors", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return AccountService.getLoginHistoryList(params);
    },
  });
}

const useAccountChangePassword = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: AccountService.accountChangePassword,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          navigate(ROUTES.ACCOUNT.PATH);
        }
      })
    },
  })
}

export {
  useChangeAccountPassword,
  useBlockingAccount,
  useGetLoginHistory,
  useAccountChangePassword
}